<p-accordionTab class="accordion-tab">
    <ng-template pTemplate="header">
    <div class="accordion-header-container">
        <div> <b class="m-0"> {{ title }} </b> </div>
        <div> {{ selectionData?.length ?? 0 }} items selected </div>
    </div>
    </ng-template>
    <div
        class="selection-text-container"
        *ngIf="selectionData === null || selectionData.length === 0"
    >
        {{ "CARRIERDB.NOTHING_SELECTED" | translate : locale.language }}
    </div>
    <div class="selection-text-container" *ngIf="selectionData !== null && selectionData.length > 0">
        <div class="selection-text-item" *ngFor="let item of selectionData">
            <span> {{ item }} </span>
        </div>
    </div>
</p-accordionTab>